(function () {
  'use strict';

  var scheduled = false;

  var ICON_LABELS = [
    ['close', 'Close'],
    ['dismiss', 'Close'],
    ['menu-toggle', 'Menu'],
    ['hamburger', 'Menu'],
    ['search', 'Search'],
    ['cart', 'Cart'],
    ['account', 'Account'],
    ['wishlist', 'Wishlist'],
    ['next', 'Next'],
    ['arrow-right', 'Next'],
    ['previous', 'Previous'],
    ['prev', 'Previous'],
    ['arrow-left', 'Previous'],
    ['play', 'Play'],
    ['pause', 'Pause'],
    ['zoom', 'Zoom']
  ];

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function hasAccessibleName(el) {
    if (el.getAttribute('aria-label')) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    if (textOf(el)) return true;
    var img = el.querySelector('img[alt]');
    if (img && img.getAttribute('alt')) return true;
    var svgTitle = el.querySelector('svg > title');
    if (svgTitle && textOf(svgTitle)) return true;
    return false;
  }

  function labelFromHref(el) {
    var href = el.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return '';
    var path = href.split('?')[0].split('#')[0].replace(/\/+$/, '');
    var segment = path.split('/').pop() || '';
    segment = segment.replace(/\.[a-z0-9]{2,5}$/i, '').replace(/[-_]+/g, ' ').trim();
    if (!segment) return '';
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }

  function labelFromChildImage(el) {
    var img = el.querySelector('img');
    if (!img) return '';
    if (img.getAttribute('alt')) return img.getAttribute('alt');
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    var file = src.split('?')[0].split('/').pop() || '';
    file = file.replace(/\.[a-z0-9]{2,5}$/i, '').replace(/[-_]+/g, ' ').trim();
    return file;
  }

  function labelFromClasses(el) {
    var classes = (el.getAttribute('class') || '').toLowerCase();
    if (!classes) return '';
    var tokens = classes.split(/[\s_-]+/);
    if (tokens.indexOf('prev') !== -1 && tokens.indexOf('next') !== -1) return '';
    for (var i = 0; i < ICON_LABELS.length; i++) {
      var parts = ICON_LABELS[i][0].split('-');
      var matched = true;
      for (var p = 0; p < parts.length; p++) {
        if (tokens.indexOf(parts[p]) === -1) matched = false;
      }
      if (matched) return ICON_LABELS[i][1];
    }
    return '';
  }

  function each(selector, callback) {
    var nodes;
    try {
      nodes = document.querySelectorAll(selector);
    } catch (error) {
      return;
    }
    for (var i = 0; i < nodes.length; i++) {
      try {
        callback(nodes[i]);
      } catch (innerError) {
        /* keep going */
      }
    }
  }

  function labelControls() {
    each('a[href]:not([aria-label]):not([aria-labelledby])', function (el) {
      if (textOf(el)) return;
      var img = el.querySelector('img[alt]');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return;
      el.setAttribute('aria-label', alt);
    });

    each('a[href]:not([aria-label]):not([aria-labelledby]):not([data-a11y-named]), button:not([aria-label]):not([aria-labelledby]):not([data-a11y-named]), [role="button"]:not([aria-label]):not([aria-labelledby]):not([data-a11y-named])', function (el) {
      if (hasAccessibleName(el)) return;
      var label = (el.getAttribute('title') || '').trim() ||
        labelFromChildImage(el) ||
        labelFromClasses(el) ||
        (el.tagName === 'A' ? labelFromHref(el) : '');
      if (!label) return;
      el.setAttribute('aria-label', label);
      el.setAttribute('data-a11y-named', 'true');
    });

    each('a[title]:not([aria-label]):not([aria-labelledby]), button[title]:not([aria-label]):not([aria-labelledby])', function (el) {
      var title = (el.getAttribute('title') || '').trim();
      if (!title) return;
      if (hasAccessibleName(el)) return;
      el.setAttribute('aria-label', title);
    });
  }

  function labelFormControls() {
    each('select[name="id"]:not([aria-label]), select[id^="product-select-"]:not([aria-label])', function (select) {
      select.setAttribute('aria-label', 'Choose a variant');
    });

    each('select#sort-by:not([aria-label]), select.sort_by:not([aria-label]), select[data-sort-by]:not([aria-label])', function (select) {
      select.setAttribute('aria-label', 'Sort by');
    });

    each('select.tag_filter:not([aria-label]), select[data-tag-filter]:not([aria-label])', function (select) {
      select.setAttribute('aria-label', 'Filter by');
    });

    each('input.contact_email:not([aria-label]):not([aria-labelledby]), input.bringToggle:not([aria-label]):not([aria-labelledby]), select.slim-select:not([aria-label]):not([aria-labelledby]), textarea.extraFieldSets:not([aria-label]):not([aria-labelledby])', function (field) {
      if (field.id && document.querySelector('label[for="' + field.id.replace(/"/g, '\\"') + '"]')) return;
      var label = field.getAttribute('placeholder') ||
        field.getAttribute('data-placeholder') ||
        field.getAttribute('name') ||
        '';
      label = label.replace(/[\[\]_-]+/g, ' ').trim();
      if (!label) return;
      field.setAttribute('aria-label', label.charAt(0).toUpperCase() + label.slice(1));
    });

    each('select:not([aria-label]):not([aria-labelledby]):not([id])', function (select) {
      var placeholder = select.getAttribute('placeholder');
      if (placeholder) select.setAttribute('aria-label', placeholder);
    });

    each('input[placeholder]:not([aria-label]):not([aria-labelledby]), textarea[placeholder]:not([aria-label]):not([aria-labelledby])', function (field) {
      var type = (field.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'reset') return;
      if (field.closest && field.closest('label')) return;
      if (field.id && document.querySelector('label[for="' + field.id.replace(/"/g, '\\"') + '"]')) return;
      var placeholder = (field.getAttribute('placeholder') || '').trim();
      if (!placeholder) return;
      field.setAttribute('aria-label', placeholder);
    });
  }

  function fixPresentationRoles() {
    each('[role="presentation"], [role="none"]', function (el) {
      if (el.tagName === 'IMG') return;
      if (!el.querySelector('a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])')) return;
      el.removeAttribute('role');
    });
  }

  function hideDecorativeElements() {
    each('svg.flickity-button-icon:not([aria-hidden]), svg.placeholder-svg:not([aria-hidden]), svg.loading-icon:not([aria-hidden]), svg.play-icon-button-control:not([aria-hidden]), svg.icon--pressed:not([aria-hidden]), svg.icon--not-pressed:not([aria-hidden])', function (icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    });

    each('.plyr__poster:not([aria-hidden])', function (poster) {
      poster.setAttribute('role', 'presentation');
      poster.setAttribute('aria-hidden', 'true');
    });

    each('.is-overlay-bg:not([aria-hidden])', function (overlay) {
      if (textOf(overlay)) return;
      if (overlay.querySelector('a, button, input, select, textarea, iframe, [tabindex]')) return;
      overlay.setAttribute('aria-hidden', 'true');
    });

    each('img:not([alt])', function (img) {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    });

    each('svg:not([aria-hidden])', function (svg) {
      if (!svg.querySelector('defs, symbol')) return;
      if (svg.querySelector('use')) return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });

    each('img[src*="/preview_images/"][alt=""]:not([role]), img[data-src*="/preview_images/"][alt=""]:not([role])', function (img) {
      img.setAttribute('role', 'presentation');
    });

    each('img[height="1"][width="1"]:not([aria-hidden]), img[src*="px.ads.linkedin.com/"]:not([aria-hidden]), img[src*="//t.co/"]:not([aria-hidden]), img[src*="facebook.com/tr"]:not([aria-hidden]), img[src*="bat.bing.com/"]:not([aria-hidden])', function (pixel) {
      pixel.setAttribute('aria-hidden', 'true');
      if (!pixel.getAttribute('alt')) pixel.setAttribute('alt', 'Analytics pixel');
    });

    each('video[autoplay][loop][muted]:not([controls]):not([aria-hidden])', function (video) {
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
    });

    each('.plyr [role="tooltip"]:not([aria-hidden])', function (tooltip) {
      tooltip.setAttribute('aria-hidden', 'true');
    });

    each('progress.plyr__progress__buffer:not([aria-label])', function (buffer) {
      buffer.setAttribute('aria-label', 'Buffered');
      buffer.setAttribute('aria-hidden', 'true');
    });
  }

  function syncPlayerControlNames() {
    each('.plyr__control[aria-label]', function (button) {
      var holder = button.querySelector('[data-plyr-name]');
      if (!holder) return;
      var label = button.getAttribute('aria-label') || '';
      if (!label) return;
      if (holder.textContent === label) return;
      holder.textContent = label;
    });
  }

  function describeFrames() {
    each('iframe:not([title])', function (frame) {
      var src = frame.getAttribute('src') || '';
      var title = 'Embedded content';
      if (src.indexOf('youtube') !== -1 || src.indexOf('youtu.be') !== -1) title = 'YouTube video player';
      else if (src.indexOf('vimeo') !== -1) title = 'Vimeo video player';
      else if (src.indexOf('spotify') !== -1) title = 'Spotify player';
      else if (src.indexOf('soundcloud') !== -1) title = 'SoundCloud player';
      else if (src.indexOf('google.com/maps') !== -1) title = 'Map';
      else if (src.indexOf('leadquizzes') !== -1) title = 'Quiz form';
      else if (src.indexOf('calendar') !== -1) title = 'Calendar';
      else title = frame.getAttribute('name') || frame.id || title;
      frame.setAttribute('title', title);
    });

    each('iframe[title]:not([aria-label]):not([aria-labelledby])', function (frame) {
      var title = (frame.getAttribute('title') || '').trim();
      if (!title) return;
      frame.setAttribute('aria-label', title);
    });

    each('link[rel="alternate"][type="application/atom+xml"][title]', function (feedLink) {
      feedLink.removeAttribute('title');
    });
  }

  function describeMedia() {
    var tracks = (window.PXUTheme && window.PXUTheme.a11yMediaTracks) || null;
    if (!tracks || !tracks.captions) return;

    each('video:not([data-a11y-tracks])', function (video) {
      video.setAttribute('data-a11y-tracks', 'true');

      if (!video.querySelector('track[kind="captions"]')) {
        var captions = document.createElement('track');
        captions.setAttribute('kind', 'captions');
        captions.setAttribute('src', tracks.captions);
        captions.setAttribute('srclang', 'en');
        captions.setAttribute('label', 'English');
        video.appendChild(captions);
      }

      if (tracks.descriptions && !video.querySelector('track[kind="descriptions"]')) {
        var descriptions = document.createElement('track');
        descriptions.setAttribute('kind', 'descriptions');
        descriptions.setAttribute('src', tracks.descriptions);
        descriptions.setAttribute('srclang', 'en');
        descriptions.setAttribute('label', 'English');
        video.appendChild(descriptions);
      }
    });
  }

  function manageCarouselFocus() {
    var focusable = 'a[href], button, input, select, textarea, iframe, video, model-viewer, [tabindex]:not([tabindex="-1"])';

    each('.product-gallery__image[aria-hidden="true"], .flickity-enabled .gallery-cell[aria-hidden="true"]', function (cell) {
      var nodes = cell.querySelectorAll(focusable);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.getAttribute('tabindex') === '-1') continue;
        el.setAttribute('data-a11y-restore-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        el.setAttribute('tabindex', '-1');
      }
    });

    each('.product-gallery__image:not([aria-hidden="true"]) [data-a11y-restore-tabindex], .flickity-enabled .gallery-cell:not([aria-hidden="true"]) [data-a11y-restore-tabindex]', function (el) {
      var previous = el.getAttribute('data-a11y-restore-tabindex');
      if (previous) {
        el.setAttribute('tabindex', previous);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute('data-a11y-restore-tabindex');
    });

    each('.flickity-enabled[tabindex]:not([role])', function (slider) {
      slider.setAttribute('role', 'region');
      if (!slider.hasAttribute('aria-roledescription')) slider.setAttribute('aria-roledescription', 'carousel');
      if (!slider.hasAttribute('aria-label') && !slider.hasAttribute('aria-labelledby')) slider.setAttribute('aria-label', 'Carousel');
    });
  }

  function allowZoom() {
    each('meta[name="viewport"]', function (meta) {
      var content = meta.getAttribute('content') || '';
      if (/user-scalable\s*=\s*(no|0)|maximum-scale\s*=\s*1(\.0+)?(\s*,|\s*$)/i.test(content)) {
        meta.setAttribute('content', 'width=device-width, initial-scale=1');
      }
    });
  }

  function apply() {
    scheduled = false;
    try {
      labelFormControls();
      fixPresentationRoles();
      hideDecorativeElements();
      syncPlayerControlNames();
      describeFrames();
      describeMedia();
      manageCarouselFocus();
      allowZoom();
      labelControls();
    } catch (error) {
      /* fixups must never break the page */
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(apply);
      } else {
        apply();
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  [500, 1500, 3000, 6000].forEach(function (delay) {
    window.setTimeout(schedule, delay);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(schedule);
    var startObserver = function () {
      if (!document.body) return;
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-label']
      });
    };
    if (document.body) {
      startObserver();
    } else {
      document.addEventListener('DOMContentLoaded', startObserver);
    }

    if (document.head) {
      new MutationObserver(schedule).observe(document.head, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['content']
      });
    }
  }
})();
